import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { palette } from "@/styles/palette";
import { fontFamily } from "@/styles/font";

const NotFound = () => {
    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate("/home");
    };

    return (
        <Container>
            <Content>
                <LogoImage src="/images/soolmoa_logo.png" alt="술모아 로고" />
                <Title>페이지를 찾을 수 없습니다</Title>
                <Description>
                    요청하신 페이지가 존재하지 않거나,
                    <br />
                    사용할 수 없는 페이지입니다.
                </Description>
                <HomeButton onClick={handleGoHome}>홈으로 가기</HomeButton>
            </Content>
        </Container>
    );
};

export default NotFound;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    padding: 20px;
    background-color: ${palette.white};
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    max-width: 400px;
`;

const LogoImage = styled.img`
    width: 120px;
    height: auto;
    margin-bottom: 40px;
`;

const Title = styled.h1`
    font-family: ${fontFamily.base};
    font-size: 24px;
    font-weight: 700;
    color: ${palette.gray[900]};
    margin-bottom: 16px;
`;

const Description = styled.p`
    font-family: ${fontFamily.base};
    font-size: 16px;
    line-height: 1.5;
    color: ${palette.gray[700]};
    margin-bottom: 32px;
`;

const HomeButton = styled.button`
    padding: 12px 24px;
    background-color: ${palette.primary};
    color: ${palette.white};
    border: none;
    border-radius: 8px;
    font-family: ${fontFamily.base};
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        background-color: ${palette.primary}ee;
    }
`;
